import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { LinqCanvasModule } from '../canvas/linq.canvas.module';
import { UIComponentsModule } from '../ui-components/ui-components.module';
import { ModelLayoutComponent } from './model/model-layout.component';
import { ModelComponentsModule } from '../model-components/model-components.module';
import { OrganisationModule } from '../organisation/organisation.module';
import { OrganisationLayoutComponent } from './organisation-home/organisation-layout.component';
import { FitTextDirective } from '../linq-utils/fit-text.directive';
import { UserModule } from '../user/user.module';
import { UsersLayoutComponent } from './users/users-layout.component';
import { OrganisationsLayoutComponent } from './organisations/organisations-layout.component';
import { LINQUtilsModule } from '../linq-utils/linq-utils.module';
import { ModelServicesModule } from '../model-services/model-services.module';
import { SidenavService } from './model/sidenav.service';
import { AdminLayoutComponent } from './admin/admin-layout.component';
import { TutorialComponent } from '../help/tutorial/tutorial-component';
import { InsightsLayoutComponent } from './insights/insights-layout.component';
import { OrganisationBillingComponent } from './billing/organisation-billing.component';
import { BillingRecordsTableComponent } from '../ui-components/billing-records/billing-records-table.component';
import { FormsModule } from '@angular/forms';
import { QueryAIComponent } from '../ai/query-ai.component';
import { SystemInterfacesComponent } from './insights/system-interfaces.component';
import { BackupsTableComponent } from '../organisation/backups/backups-table.component';
import { OnboardingModelComponent } from './onboarding/onboarding-model.component';
import { TemporalSettingsComponent } from '../temporal/temporal-settings.component';
import { InsightsModule } from '../insights/insights.module';
import { TableComponent } from '../ui-components/table/table-component';
import { OnboardingPaletteComponent } from './onboarding/onboarding-palette.component';
import { ChartsModule } from '../charts/charts.module';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { IntroductionLayoutComponent } from './introduction/introduction-layout.component';
import { ModelsListComponent } from './analysis/models-list.component';
import { EPMModule } from '../epm/epm-module';
import { WorkforceReportComponent } from '../workforce/workforce-report.component';
import { SystemsReportComponent } from '../systems/systems-report.component';
import { TagsAnalysisComponent } from '../tags/tags-analysis.component';
import { InformationAnalysisComponent } from '../information/information-analysis.component';
import { SimulationResultsComponent } from '../temporal/simulation-results.component';
import { AnalysisLayoutComponent } from './analysis/analysis-layout.component';
import { LensAnalysisLayoutComponent } from './lens-analysis/lens-analysis-layout.component';
import { OverviewLayoutComponent } from './overview/overview-layout.component';
import { ContextGraphButtonComponent } from '../analysis/context-graph-button.component';
import { NodesLayoutComponent } from './nodes/nodes-layout.component';
import { AnalysisHeaderComponent } from '../analysis/analysis-header.component';
import { FullModelComponent } from '../analysis/full-model.component';
import { LensGraphComponent } from '../lenses/lens-graph.component';
import { LensSwitcherComponent } from '../lenses/lens-switcher.component';
import { BusinessProcessModule } from '../business-process/business-process.module';
import { GettingStartedChecklistComponent } from './organisation-home/getting-started-checklist.component';
import { OverviewCardComponent } from '../analysis/overview-card.component';
import { HelpLibraryComponent } from './help-library/help-library.component';
import { VideoComponent } from '../ui-components/video/video.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    ModelLayoutComponent,
    OrganisationLayoutComponent,
    UsersLayoutComponent,
    OrganisationsLayoutComponent,
    AdminLayoutComponent,
    InsightsLayoutComponent,
    OrganisationBillingComponent,
    OnboardingModelComponent,
    OnboardingPaletteComponent,
    IntroductionLayoutComponent,
    ModelsListComponent,
    AnalysisLayoutComponent,
    LensAnalysisLayoutComponent,
    OverviewLayoutComponent,
    NodesLayoutComponent,
    FullModelComponent,
    HelpLibraryComponent,
  ],
  exports: [],
  imports: [
    SimulationResultsComponent,
    WorkforceReportComponent,
    SystemsReportComponent,
    TagsAnalysisComponent,
    InformationAnalysisComponent,
    LensGraphComponent,
    ContextGraphButtonComponent,
    LensSwitcherComponent,
    AnalysisHeaderComponent,
    ModelServicesModule,
    ModelComponentsModule,
    InsightsModule,
    MaterialModule,
    LinqCanvasModule,
    OrganisationModule,
    UserModule,
    UIComponentsModule,
    LINQUtilsModule,
    FitTextDirective,
    TutorialComponent,
    QueryAIComponent,
    BillingRecordsTableComponent,
    FormsModule,
    SystemInterfacesComponent,
    BackupsTableComponent,
    TemporalSettingsComponent,
    TableComponent,
    ChartsModule,
    UIComponentsModule,
    ClipboardModule,
    EPMModule,
    BusinessProcessModule,
    GettingStartedChecklistComponent,
    OverviewCardComponent,
    VideoComponent,
    RouterModule,
  ],
  providers: [SidenavService],
})
export class ModelLayoutModule {}
